import React, { useEffect, useState } from 'react';
import './CartBannerContent.scss';
import { COLORS } from '../../../../constants/colors';
import Owl from '../../Graphics/Owl';
import CTAButton from '../../CTA/CTAButton/CTAButton';
import Close from '../../Icons/Close';
import Button from '../../../@redantler/redantler-npm-button-react';
import { BREAKPOINTS } from '../../../../constants/breakpoints';

const DESKTOP_WIDTH = BREAKPOINTS.large;

/**
 * Renders the cart banner type
 * @param {string} message
 * @param {function} clearState
 * @param {function} setState
 * @returns {JSX.Element}
 * @constructor
 */
const CartBannerContent = ({ message, clearState, setState }) => {
  const [isDesktop, setIsDesktop] = useState(null);

  useEffect(() => {
    setIsDesktop(window.innerWidth > DESKTOP_WIDTH);
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleResize = () => {
    setIsDesktop(window.innerWidth > DESKTOP_WIDTH);
  };

  return (
    <div className="c-cart-banner-content">
      <div className="c-cart-banner-content__inner">
        <div className="c-cart-banner-content__left">
          <Owl color={COLORS.white} />
          <div className="c-cart-banner-content__message body-1 color-white">
            <p>{message || 'An item was added to your cart'}</p>
          </div>
        </div>
        <div className="c-cart-banner-content__right">
          {isDesktop && (
            <div className="c-cart-banner-content__cta">
              <CTAButton
                link={'/cart'}
                type="secondary"
                text={'View Cart'}
                additionalClasses="cta color-white"
              />
            </div>
          )}
          <div className="c-cart-banner-content__dismiss">
            <Button
              ariaLabel={'Close banner'}
              onClick={() => {
                setState({
                  isEntering: false,
                  isExiting: true,
                });
                clearState();
              }}
            >
              <Close color={COLORS.white} />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartBannerContent;
